import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";

/**
 * basic proxy for this framework
 *
 * @author dkoehler
 *
 */
export class AbstractProxy {
    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
